// Pricing + scheduling rules for PetMoon (client-safe).

export const BASE_FARE_MXN = 35;
export const PER_KM_MXN = 12;
/** Tarifa mínima por viaje. */
export const MIN_FARE_MXN = 80;

/** Duración de cada franja horaria y margen de limpieza/tráfico. */
export const SLOT_MINUTES = 40;
export const BUFFER_MINUTES = 45;
export const SLOT_START_HOUR = 8;
export const SLOT_END_HOUR = 20;
/** Viajes en paralelo por franja (capacidad de flota). */
export const FLEET_CAPACITY = 1;

export interface QuoteResult {
  distanciaKm: number;
  duracionMin: number;
  precioMxn: number;
  aproximado: boolean;
}

export function priceFor(distanciaKm: number, idaYVuelta: boolean): number {
  const km = idaYVuelta ? distanciaKm * 2 : distanciaKm;
  return Math.max(MIN_FARE_MXN, Math.round(BASE_FARE_MXN + km * PER_KM_MXN));
}

export function formatMXN(value: number): string {
  return `$${Math.round(value).toLocaleString("es-MX")} MXN`;
}

/** "14:00" -> 840 */
export function toMinutes(time: string): number {
  const [h, m] = time.split(":").map(Number);
  return (h ?? 0) * 60 + (m ?? 0);
}

export function fromMinutes(total: number): string {
  const h = Math.floor(total / 60);
  const m = total % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

export function formatSlotLabel(time: string): string {
  const mins = toMinutes(time);
  const h24 = Math.floor(mins / 60);
  const m = mins % 60;
  const suffix = h24 < 12 ? "AM" : "PM";
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${h12}:${String(m).padStart(2, "0")} ${suffix}`;
}

/** Franjas fijas de SLOT_MINUTES entre SLOT_START_HOUR y SLOT_END_HOUR. */
export function generateTimeSlots(): string[] {
  const slots: string[] = [];
  const end = SLOT_END_HOUR * 60;
  for (let t = SLOT_START_HOUR * 60; t + SLOT_MINUTES <= end; t += SLOT_MINUTES) {
    slots.push(fromMinutes(t));
  }
  return slots;
}

export interface BusyRange {
  hora_inicio: string;
  hora_fin_estimada: string;
}

/** Una franja está ocupada si su bloque (viaje + buffer) se empalma con otra reserva. */
export function isSlotOccupied(slot: string, busy: BusyRange[]): boolean {
  const start = toMinutes(slot);
  const end = start + SLOT_MINUTES + BUFFER_MINUTES;
  const overlaps = busy.filter((b) => {
    const bStart = toMinutes(b.hora_inicio.slice(0, 5));
    const bEnd = toMinutes(b.hora_fin_estimada.slice(0, 5));
    return bStart < end && bEnd > start;
  });
  return overlaps.length >= FLEET_CAPACITY;
}
